import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';

import Breadcrumb from '../../molecules/breadcrumb/breadcrumb';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import StyledHighlightStage from './hightlightStage.style';
import GuidedMask from '../../icons/guided-mask/guidedMask';
import { getThemes } from '../../../stylesheets/themes';

const Image = dynamic(() => import('../../atoms/image/image'));

const sizes = [
  {
    condition: 'min-width: 940px',
    width: '50vw'
  },
  {
    width: '80vw'
  }
];

const HighlightStage = ({
  headline,
  subline,
  introCopy,
  titleImage,
  breadcrumb,
  guidedTourTeaserImage,
  siteTheme,
  globalTheme,
  ...props
}) => (
  <StyledHighlightStage>
    {guidedTourTeaserImage && (
      <div className="highlight-stage__image">
        <Image {...guidedTourTeaserImage} lazy="default" sizes={sizes} />

        <div className="highlight-stage__image-underlay">
          {guidedTourTeaserImage.credits && (
            <div
              className="highlight-stage__credits"
              dangerouslySetInnerHTML={{ __html: guidedTourTeaserImage.credits }}
            />
          )}
          <GuidedMask
            className="highlight-stage__image-mask-overlay"
            fillColor={getThemes(100, siteTheme, globalTheme)?.siteTheme?.primary}
          />
        </div>
      </div>
    )}

    <div className="highlight-stage__inner-content">
      {breadcrumb && <Breadcrumb entries={breadcrumb} />}

      <Container className="highlight-stage__wrapper">
        {subline && (
          <Headline tag="h3" subline>
            {subline}
          </Headline>
        )}

        <Headline tag="h1" primary>
          {headline}
        </Headline>

        {introCopy && (
          <MixedCopy focused fullWidth html={introCopy} className="highlight-stage__introduction" />
        )}
      </Container>
    </div>
  </StyledHighlightStage>
);

HighlightStage.propTypes = {
  headline: PropTypes.string,
  subline: PropTypes.string,
  introCopy: PropTypes.string,
  titleImage: PropTypes.shape({
    imageFormat: PropTypes.oneOf(['portrait', 'landscape']),
    credits: PropTypes.string
  }),
  breadcrumb: PropTypes.arrayOf(PropTypes.shape()),
  guidedTourTeaserImage: PropTypes.shape(),
  siteTheme: PropTypes.string,
  globalTheme: PropTypes.string
};

const mapStateToProps = state => ({
  headline: state.app.pageData.headline,
  subline: state.app.pageData.subline,
  introCopy: state.app.pageData.introCopy,
  guidedTourTeaserImage: state.app.pageData.guidedTourTeaserImage,
  breadcrumb: state.app.pageData.breadcrumb,
  siteTheme: state.app.pageData.siteTheme,
  globalTheme: state.app.pageData.globalTheme
});

export { HighlightStage as StageComponent };
export default connect(mapStateToProps)(HighlightStage);
